import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=1329a800&"
import script from "./TaskForm.vue?vue&type=script&lang=js&"
export * from "./TaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1329a800')) {
      api.createRecord('1329a800', component.options)
    } else {
      api.reload('1329a800', component.options)
    }
    module.hot.accept("./TaskForm.vue?vue&type=template&id=1329a800&", function () {
      api.rerender('1329a800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Task/TaskForm.vue"
export default component.exports